export const VOUCHER_PAYMENTS_STATUS = {
  FOR_APPROVE: 0,
  PROCESSING: 1,
  PAID: 3,
  FAILED: 2,
  IGNORED: 4
};
